import { useQuery } from '@tanstack/react-query';

import { PaymentStatistic } from 'src/features/statistic/types';
import axios from 'src/lib/axios';
import { QueryConfig } from 'src/lib/react-query';
import { CURRENCY } from 'src/types';
import { formatResourcePath } from 'src/utils/regex';

const RESOURCE = `sp-core/:parkingId/stats/payment-stats/`;

type QueryFnType = typeof queryFn;

interface DTO {
    from_datetime: string;
    to_datetime: string;
    currency?: CURRENCY;
    parkingId: string;
}
const queryFn = ({ parkingId, ...params }: DTO): Promise<PaymentStatistic> => {
    return axios.get(formatResourcePath(RESOURCE, { parkingId }), { params });
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });

export { RESOURCE as GET_PAYMENT_STATISTIC_RESOURCE, useQueryHook as useGetPaymentStatistic };
